import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useAuthStoreV1 } from '@/stores/authStore_v1';
import { agentsAxios, skillsAuthHeaders } from '@/services/skills';
import { AGENT_RUNS_ENDPOINT } from '@/services/reports';

export function useStopAgentRun() {
  const queryClient = useQueryClient();
  const orgId = useAuthStoreV1((s) => s.selectedOrg?.id ?? null);

  return useMutation({
    mutationFn: (runId: string) =>
      agentsAxios.post(
        `${AGENT_RUNS_ENDPOINT}/${encodeURIComponent(runId)}/stop`,
        {},
        { headers: skillsAuthHeaders() },
      ),
    onSuccess: (_data, runId) => {
      void queryClient.invalidateQueries({ queryKey: ['agent-runs', orgId] });
      void queryClient.invalidateQueries({ queryKey: ['agent-run', runId] });
    },
  });
}
